import { CommonModule } from '@angular/common';
import { Component, ElementRef, Input, ViewChild } from '@angular/core';

/** Shared page hierarchy; actions remain owned by each feature page. */
@Component({
  selector: 'app-page-header',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss']
})
export class PageHeaderComponent {
  @Input() title = '';
  @Input() description = '';
  @ViewChild('pageTitle', { static: true }) private pageTitle: ElementRef<HTMLHeadingElement>;

  focusTitle(): void {
    this.pageTitle?.nativeElement.focus({ preventScroll: true });
  }
}
